var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getConfig } from './configReader';
import { OPERATION, } from '../types/searchTypes';
import { DATASETVERSION } from '../components/App/ApplicationConfig';
const config = getConfig();
const createStacSearchQuery = (searchQuery, project, limit) => {
    const mappingBase = project.title.toLowerCase();
    const filters = {
        op: 'and',
        args: [],
    };
    const filterGroups = {};
    searchQuery.selectedItems.forEach((node) => {
        let propertyName;
        let facetKey;
        const prefix = project.title === 'CORDEX-CMIP6' ? 'driving_' : '';
        switch (node.facetId) {
            case 'project':
                return;
            case 'variable':
                propertyName = `${mappingBase}:variable_id`;
                facetKey = 'variable';
                break;
            case 'member_id':
                // because member_id property contains a year in front of it
                propertyName = `${mappingBase}:${prefix}variant_label`;
                facetKey = 'member_id';
                break;
            case 'experiment_id':
                // because experiment_id for CORDEX-CMIP6 has the driving_ prefix
                propertyName = `${mappingBase}:${prefix}${node.facetId}`;
                facetKey = node.facetId;
                break;
            default:
                propertyName = `${mappingBase}:${node.facetId}`;
                facetKey = node.facetId;
        }
        if (!filterGroups[facetKey]) {
            filterGroups[facetKey] = [];
        }
        filterGroups[facetKey].push({
            op: '=',
            args: [{ property: propertyName }, node.fieldId],
        });
    });
    // Build filter args: OR within groups, AND between groups
    Object.values(filterGroups).forEach((group) => {
        if (group.length === 1) {
            filters.args.push(group[0]);
        }
        else {
            filters.args.push({
                op: 'or',
                args: group,
            });
        }
    });
    const requestBody = {
        collections: [project.title],
        limit,
        sortBy: ['created'],
    };
    if (filters.args.length > 0) {
        Object.assign(requestBody, { filter: filters });
    }
    return requestBody;
};
const buildNodeParameter = (selectedNodes) => {
    switch (selectedNodes.length) {
        case 0:
            return '';
        case 1:
            return `&data_node=${selectedNodes[0]}`;
        default:
            return `&data_node=${selectedNodes.join(',')}`;
    }
};
/** Remove "project" as it is fixed. Flatten all other. */
const generateFacetArray = (project) => project.mainFacets
    .map((facet) => facet.id)
    .filter((facetId) => facetId !== 'project');
export const getFacetsInfoStac = (searchQuery, project) => {
    // query 1 The query for the facet selection
    const mappingBase = project.title.toLowerCase().replace('-', '_');
    console.log(project.title);
    const lookupDict = {
        CMIP6: {
            variable: `${mappingBase}_variable_id_frequency`,
            frequency: `${mappingBase}_frequency_frequency`,
            experiment_id: `${mappingBase}_experiment_id_frequency`,
            source_id: `${mappingBase}_source_id_frequency`,
            member_id: `${mappingBase}_variant_label_frequency`,
        },
        'CORDEX-CMIP6': {
            variable: `${mappingBase}_variable_id_frequency`,
            frequency: `${mappingBase}_frequency_frequency`,
            experiment_id: `${mappingBase}_driving_experiment_id_frequency`,
            source_id: `${mappingBase}_source_id_frequency`,
            member_id: `${mappingBase}_driving_variant_label_frequency`,
        },
        CMIP7: {
            variable: `${mappingBase}_variable_id_frequency`,
            frequency: `${mappingBase}_frequency_frequency`,
            experiment_id: `${mappingBase}_experiment_id_frequency`,
            source_id: `${mappingBase}_source_id_frequency`,
            member_id: `${mappingBase}_variant_label_frequency`,
        },
    };
    const mappingstac = lookupDict[project.title];
    const endobject = {
        variable: {},
        frequency: {},
        experiment_id: {},
        source_id: {},
        member_id: {},
    };
    const urlToQuery = 'https://discovery.east.esgf.io/aggregate';
    // const urlToQuery = 'https://discovery.west.esgf.io/aggregate';
    // const urlToQuery = 'https://discovery-int.west.esgf.io/aggregate';
    return new Promise((resolve, reject) => {
        Promise.all(project.mainFacets.map((facet) => __awaiter(void 0, void 0, void 0, function* () {
            const allOtherFacetsinSelection = {
                selectedItems: searchQuery.selectedItems.filter((tempFacet) => tempFacet.facetId !== facet.id),
            };
            const requestBody = createStacSearchQuery(allOtherFacetsinSelection, project, undefined);
            requestBody.aggregations = [mappingstac[facet.id]];
            return fetch(urlToQuery, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            })
                .then((res) => (res.ok ? res.json() : undefined))
                .then((data) => {
                return data;
            });
        })))
            .then((mFacets) => {
            mFacets.forEach((data) => {
                data === null || data === void 0 ? void 0 : data.aggregations.forEach((stacfacet) => {
                    if (stacfacet.name.includes('variable_id_frequency')) {
                        endobject.variable = Object.fromEntries(stacfacet.buckets.map((value) => [value.key, value.frequency]));
                    }
                    if (stacfacet.name.includes('frequency_frequency')) {
                        endobject.frequency = Object.fromEntries(stacfacet.buckets.map((value) => [value.key, value.frequency]));
                    }
                    if (stacfacet.name.includes('experiment_id_frequency')) {
                        endobject.experiment_id = Object.fromEntries(stacfacet.buckets.map((value) => [value.key, value.frequency]));
                    }
                    if (stacfacet.name.includes('source_id_frequency')) {
                        endobject.source_id = Object.fromEntries(stacfacet.buckets.map((value) => [value.key, value.frequency]));
                    }
                    if (stacfacet.name.includes('variant_label_frequency')) {
                        endobject.member_id = Object.fromEntries(stacfacet.buckets.map((value) => [value.key, value.frequency]));
                    }
                });
            });
            resolve(endobject);
        })
            .catch((e) => {
            reject(e);
        });
    });
};
export const getFacetsInfoESGF = (searchQuery, project, selectedNodes, limit) => {
    return new Promise((resolve, reject) => {
        const mainFacets = generateFacetArray(project);
        const esgfsearchurl = config.esgfsearch;
        const facets = mainFacets.join(',');
        const nodes = buildNodeParameter(selectedNodes);
        const mainFacetToQuery = [];
        mainFacets.forEach((thisFacet) => {
            // query 1 The query for the facet selection
            let url = `${esgfsearchurl}format=application%2Fsolr%2Bjson&facets=${facets}${nodes}&limit=${limit}${DATASETVERSION}`;
            /**   Append to this facet's url parameters from the selection, only if they come from other facets.
             This ensures that further members of this facet can be selected and other main facets update on the selection. */
            const allOtherFacetsinSelection = searchQuery.selectedItems.filter((facet) => facet.facetId !== thisFacet);
            allOtherFacetsinSelection.forEach((facet) => {
                url += `&${facet.facetId}=${facet.fieldId}`;
            });
            mainFacetToQuery.push({ url, facetId: thisFacet });
        });
        Promise.all(mainFacetToQuery.map((facet) => __awaiter(void 0, void 0, void 0, function* () {
            return fetch(facet.url)
                .then((res) => res.json())
                .then((data) => ({
                data,
                facetId: facet.facetId,
            }));
        })))
            .then(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (mFacets) => {
            const facetInfo = {};
            // eslint-disable-next-line
            mFacets.forEach((mainFacet) => {
                const facetResult = {};
                const facetToProcess = mainFacet.data.facet_counts.facet_fields[mainFacet.facetId];
                if (!facetToProcess)
                    return;
                // Array with key & count dissolved, e.g. ["1hr", 10, "3hrs", 20], hence:
                for (let j = 0; j < facetToProcess.length / 2; j += 1) {
                    facetResult[facetToProcess[j * 2]] = facetToProcess[j * 2 + 1];
                }
                facetInfo[mainFacet.facetId] = facetResult;
            });
            resolve(facetInfo);
        })
            .catch((e) => {
            console.error(e);
            reject(e);
        });
    });
};
/**
 * For a searchquery and project find all the options for the otherfacets and the number of results
 * @param searchQuery
 * @param project
 */
export const getFacetsInfo = (searchQuery, project, selectedNodes) => {
    let results;
    if (project.title === 'CMIP7' || project.title === 'CORDEX-CMIP6') {
        // limit is needed for the ESGF query but not for stac since we use the aggregate endpoint for this now.
        // it also does not do anything with nodes so that's why we dont use selectedNodes here.
        results = getFacetsInfoStac(searchQuery, project);
        return results;
    }
    const limit = 0;
    results = getFacetsInfoESGF(searchQuery, project, selectedNodes, limit);
    return results;
};
const getSearchResultsESFG = (searchQuery, project, selectedNodes, limit) => {
    // NOTE for future reference
    // CMIP6 is able to get search results for all
    //     datasets with all facets: variable, frequency, experiment, model,
    //     and member. The returned dataset size is therefore correct
    // CMIP5 can filter datasets on frequency, experiment, model and member
    //     - so not variable! Therefore, the datasetsize returned in this function
    //     can be an over-estimation when the user also has selected a variable
    //     Only when the user expands the results, the "resolveFilesOfDataset"
    //     function will return the true number of files with the selected variable
    return new Promise((resolve, reject) => {
        const allFacets = project.mainFacets;
        const facetsToQuery = allFacets.map((facet) => {
            return facet.id;
        });
        facetsToQuery.push('project');
        const facets = facetsToQuery.join(',');
        const nodes = buildNodeParameter(selectedNodes);
        const esgfsearchurl = config.esgfsearch;
        // query 2 (The first table of results after selecting via the 5 parameter overview)
        let urlToQuery = `${esgfsearchurl}format=application%2Fsolr%2Bjson&facets=${facets}${nodes}&limit=${limit}${DATASETVERSION}`;
        searchQuery.selectedItems.forEach((facet) => {
            urlToQuery += `&${facet.facetId}=${facet.fieldId}`;
        });
        fetch(urlToQuery)
            .then((res) => res.json())
            .then((result) => {
            resolve({
                query: searchQuery,
                results: result.response.docs.map((doc) => ({
                    title: doc.title,
                    id: doc.id,
                    fileNumber: doc.number_of_files,
                    version: doc.version,
                    size: doc.size,
                    citationUrl: doc.citation_url,
                    instanceId: doc.instance_id,
                    dataNode: doc.data_node,
                    startTime: doc.datetime_start ? doc.datetime_start : '',
                    endTime: doc.datetime_stop ? doc.datetime_stop : '',
                    // eslint-disable-next-line no-nested-ternary
                    variable: doc.variable
                        ? doc.variable
                        : doc.variable_id
                            ? doc.variable_id
                            : '',
                })),
            });
        })
            .catch((e) => {
            console.error(e);
            reject(e);
        });
    });
};
const getSearchResultStac = (searchQuery, project, selectedNodes, limit) => {
    return new Promise((resolve, reject) => {
        // query 2 (The first table of results after selecting via the 5 parameter overview)
        const requestBody = createStacSearchQuery(searchQuery, project, limit);
        // CORDEX-CMIP6
        const url = 'https://discovery.east.esgf.io/search';
        // const url = 'https://discovery.west.esgf.io/search';
        const mappingBase = project.title.toLowerCase();
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        })
            .then((res) => res.json())
            .then((result) => {
            var _a;
            return {
                query: searchQuery,
                results: (_a = result === null || result === void 0 ? void 0 : result.features) === null || _a === void 0 ? void 0 : _a.flatMap((feature) => {
                    var _a;
                    if (!feature.assets) {
                        return [];
                    }
                    const filteredAssets = Object.entries(feature.assets).filter(([key]) => !key.startsWith('globus'));
                    // Calculate total size from all data assets
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const totalSize = filteredAssets.reduce((sum, [_, asset]) => {
                        const stacAsset = asset;
                        return sum + (stacAsset['file:size'] || 0);
                    }, 0);
                    const citationUrl = ((_a = feature.links.find((link) => link.rel === 'cite-as')) === null || _a === void 0 ? void 0 : _a.href) || '';
                    return filteredAssets.flatMap(
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    ([assetKey, asset]) => {
                        const stacAsset = asset;
                        const datasets = [];
                        // feature.properties.title and feature.id are the same
                        const title = feature.id;
                        // Add main asset (ceda.ac.uk)
                        const dataNode = stacAsset['alternate:name'] || '';
                        const varmapping = `${mappingBase}:variable_id`;
                        datasets.push({
                            title,
                            id: `${title}`,
                            // id: `${title}|${dataNode}`, // node and title
                            fileNumber: filteredAssets.length,
                            version: feature.properties.version,
                            size: totalSize,
                            // prettier-ignore
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            citationUrl: citationUrl,
                            instanceId: feature.properties.title,
                            dataNode,
                            startTime: feature.properties.start_datetime,
                            endTime: feature.properties.end_datetime,
                            variable: feature.properties[varmapping],
                        });
                        // Add alternates (e.g., dkrz.de)
                        if (stacAsset.alternate &&
                            typeof stacAsset.alternate === 'object') {
                            Object.entries(stacAsset.alternate).forEach(
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ([alternateName, _]) => {
                                // Skip non-node entries like OPENDAP, HTTPServer
                                if (alternateName === 'OPENDAP' ||
                                    alternateName === 'HTTPServer') {
                                    return;
                                }
                                datasets.push({
                                    title,
                                    id: `${title}|${alternateName}`,
                                    fileNumber: filteredAssets.length,
                                    version: feature.properties.version,
                                    size: totalSize,
                                    // prettier-ignore
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    citationUrl: citationUrl,
                                    instanceId: feature.properties.title,
                                    dataNode: alternateName,
                                    startTime: feature.properties.start_datetime,
                                    endTime: feature.properties.end_datetime,
                                    variable: feature.properties[varmapping],
                                });
                            });
                        }
                        return datasets;
                    });
                }),
            };
        })
            .then((data) => {
            var _a;
            const x = data;
            const unique = Array.from(new Map((_a = data === null || data === void 0 ? void 0 : data.results) === null || _a === void 0 ? void 0 : _a.map((item) => [JSON.stringify(item), item])).values());
            x.results = unique;
            return data;
        })
            .then((data) => {
            resolve(data);
        })
            .catch((e) => {
            console.error(e);
            reject(e);
        });
    });
};
/**
 * For a searchquery and project find all the search results
 * @param searchQuery
 * @param project
 */
export const getSearchResults = (searchQuery, project, selectedNodes, limit) => {
    let results;
    if (project.title === 'CMIP7' || project.title === 'CORDEX-CMIP6') {
        results = getSearchResultStac(searchQuery, project, selectedNodes, limit);
        return results;
    }
    results = getSearchResultsESFG(searchQuery, project, selectedNodes, limit);
    return results;
};
export const promiseAllProgress = (listOfPromises, progressPercentageCallback) => {
    let d = 0;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    progressPercentageCallback && progressPercentageCallback(0);
    // eslint-disable-next-line no-restricted-syntax
    for (const p of listOfPromises) {
        // eslint-disable-next-line @typescript-eslint/no-loop-func
        p.then(() => {
            d += 1;
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            progressPercentageCallback &&
                progressPercentageCallback((d * 100) / listOfPromises.length);
        }).catch((err) => console.error(err));
    }
    return Promise.all(listOfPromises);
};
export const filterFiles = (files, variables) => {
    if (variables.length === 0) {
        return files;
    }
    const results = files.filter((file) => variables.some((variable) => 
    // Mind the underscore here, to prevent false results, e.g. with tas vs tasmin
    file.title.slice(0, variable.length + 1).includes(`${variable}_`)));
    return results;
};
const resolveFilesOfDatasetESGF = (id, operation, selectedNodes) => {
    // IMPORTANT - see comment @ getSearchResultsESFG
    return new Promise((resolve, reject) => {
        const esgfsearchurl = config.esgfsearch;
        const nodes = buildNodeParameter(selectedNodes);
        // query 3 (When collapsing the row in the first table to get the files in that result)
        const urlToQuery = `${esgfsearchurl}format=application%2Fsolr%2Bjson&type=File&dataset_id=${id}&limit=1000${nodes}&${DATASETVERSION}`;
        fetch(urlToQuery)
            .then((res) => res.json())
            .then((result) => {
            const results = result.response.docs.map((doc) => {
                const urlHTTPServerIndex = doc.url.findIndex((url) => url.includes(operation === OPERATION.SUBSETTING ? '|OPENDAP' : '|HTTPServer'));
                let httpServerURL = '';
                if (urlHTTPServerIndex !== -1) {
                    httpServerURL = doc.url[urlHTTPServerIndex].substring(0, doc.url[urlHTTPServerIndex].indexOf('|'));
                    if (operation === OPERATION.SUBSETTING &&
                        httpServerURL.substring(httpServerURL.length - 5) === '.html') {
                        httpServerURL = httpServerURL.substring(0, httpServerURL.length - 5);
                    }
                }
                const fileProps = {
                    instanceId: doc.instance_id,
                    size: doc.size,
                    url: httpServerURL,
                    checksum: doc.checksum[0],
                    checksumType: doc.checksum_type[0],
                    replica: doc.replica,
                    title: doc.title,
                    variable: doc.variable,
                };
                return fileProps;
            });
            const dataSetContents = {
                datasetId: id,
                fileList: results,
            };
            resolve(dataSetContents);
        })
            .catch((e) => {
            console.error(e);
            reject(e);
        });
    });
};
const resolveFilesOfDatasetSTAC = (idWithNode, operation) => {
    return new Promise((resolve, reject) => {
        // query 3 (When collapsing the row in the first table to get the files in that result)
        const id = idWithNode.split('|')[0];
        const node = idWithNode.split('|')[1];
        const urlParams = new URLSearchParams(window.location.search);
        const project = urlParams.get('project');
        const urlToQuery = `https://discovery.east.esgf.io/collections/${project}/items/${id}`;
        // const urlToQuery = `https://discovery.west.esgf.io/collections/${project}/items/${id}`;
        // const urlToQuery = `https://discovery.west.esgf.io/collections/CMIP6/items/${id}`;
        fetch(urlToQuery)
            .then((res) => res.json())
            .then((result) => {
            const assets = result.assets || {};
            const results = Object.entries(assets)
                .filter(([key]) => !key.startsWith('globus'))
                //   eslint-disable-next-line @typescript-eslint/no-unused-vars
                .map(([_, asset]) => {
                var _a, _b, _c;
                const stacAsset = asset;
                const { href } = stacAsset;
                let httpServerURL = null;
                if (operation === OPERATION.SUBSETTING) {
                    // For subsetting, use OPeNDAP URL if available
                    httpServerURL = ((_a = stacAsset.alternate) === null || _a === void 0 ? void 0 : _a.OPENDAP) || href;
                }
                else {
                    // For download, use HTTPServer URL if available
                    httpServerURL = ((_b = stacAsset.alternate) === null || _b === void 0 ? void 0 : _b.HTTPServer) || href;
                }
                let url = stacAsset.href;
                // If node matches the main asset's alternate:name, use the main href
                // Otherwise, if node matches an alternate key, use that alternate's href
                if (stacAsset.alternate &&
                    typeof stacAsset.alternate === 'object' &&
                    stacAsset.alternate[node]) {
                    const nodeAlternate = stacAsset.alternate[node];
                    if (typeof nodeAlternate === 'object' &&
                        nodeAlternate !== null &&
                        'href' in nodeAlternate) {
                        url = nodeAlternate.href;
                    }
                }
                else if (stacAsset['alternate:name'] === node) {
                    url = stacAsset.href;
                }
                // const title = result.properties.title.slice(0, result.properties.title.lastIndexOf('.'));
                // const fileProps: ESGFFileProperties = {
                //   instanceId: asset['file:instance_id'] || '',
                //   size: asset['file:size'],
                //   url: url,
                //   checksum: asset['file:checksum'] ,
                //   checksumType: asset['file:checksum'],
                //   replica: 'false',
                //   // title: title,
                //   title: asset["href"].split('/').pop(),
                //   variable: result.properties?.['cmip6:variable_id'] || '',
                // };
                // return
                const title = url.split('/').pop() || '';
                const fileProps = {
                    instanceId: `${result.id}.${title}`,
                    size: stacAsset['file:size'],
                    url: httpServerURL,
                    checksum: stacAsset['file:checksum'],
                    checksumType: 'SHA256',
                    // checksumType: asset['file:checksum'],
                    replica: 'false',
                    title,
                    variable: ((_c = result.properties) === null || _c === void 0 ? void 0 : _c['cmip6:variable_id']) || '',
                };
                return fileProps;
            });
            const dataSetContents = {
                datasetId: id,
                fileList: results,
            };
            resolve(dataSetContents);
        })
            .catch((e) => {
            console.error(e);
            reject(e);
        });
    });
};
/**
 * Returns the contents of an ESGF dataset, like the list of files.
 * @param dataset Dataset object with an id property containing the id of the dataset.
 */
export const resolveFilesOfDataset = (id, operation, selectedNodes) => {
    const urlParams = new URLSearchParams(window.location.search);
    const project = urlParams.get('project');
    if (project === 'CMIP7' || project === 'CORDEX-CMIP6') {
        return resolveFilesOfDatasetSTAC(id, operation);
    }
    return resolveFilesOfDatasetESGF(id, operation, selectedNodes);
};
/**
 * Returns the contents of multiple ESGF datasets, like the list of files.
 * @param dataset Dataset object with an id property containing the id of the dataset.
 * @param progressPercentageCallback Callback which indicates how far the list is completed.
 */
export const getFilesForDatasets = (datasetIds, operation, nodes, progressPercentageCallback) => {
    return new Promise((resolve, reject) => {
        promiseAllProgress(datasetIds.map((id) => resolveFilesOfDataset(id, operation, nodes)), progressPercentageCallback)
            .then(resolve)
            .catch(reject);
    });
};
